import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'variableBenefitAgeForMinimumCalculationName'
})
export class VariableBenefitAgeForMinimumCalculationNamePipe implements PipeTransform {
  transform(minimumAgeSpouseId: number | null | undefined): string {
    if (minimumAgeSpouseId) {
      return $localize`Spouse's Age`;
    } else {
      return $localize`Member's Age`;
    }
  }
}
